import { ReportViewResponse } from '../../models/report-view.models';
import * as Models from '../../models/models-index';

export class ReportViewState {
    reportName: string;
    config: ReportViewResponse;
    filters: Models.ReportViewFilter[];
    filterSelections: Models.ReportViewFilterSelection[];
    perspectives: Models.ReportViewPerspective[];
    selectedPerspective: Models.ReportViewPerspective;
}

export class ReportViewsState {
    reports: ReportViewState[];
}

export const initialReportViewsState: ReportViewsState = {
    reports: []
};